<mat-dialog-content>
    <span mat-dialog-title style="margin: 0px;">Termin bearbeiten</span>


    <div style="display: flex;">
        <mat-form-field style="margin-right: 20px;">
            <input [disabled]="!(firebaseService.admin | async)?.superAdmin && !(data.termin.type === 'uAntrag' && onlyMe)" matInput [matDatepicker]="startDatePicker" placeholder="Von" [(ngModel)]="data.termin.StartTime">
            <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
            <mat-datepicker [disabled]="!(firebaseService.admin | async)?.superAdmin && !(data.termin.type === 'uAntrag' && onlyMe)" #startDatePicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field>
            <input [disabled]="!(firebaseService.admin | async)?.superAdmin && !(data.termin.type === 'uAntrag' && onlyMe)" matInput [matDatepicker]="endDatePicker" placeholder="Bis" [(ngModel)]="data.termin.EndTime">
            <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
            <mat-datepicker [disabled]="!(firebaseService.admin | async)?.superAdmin && !(data.termin.type === 'uAntrag' && onlyMe)" #endDatePicker></mat-datepicker>
        </mat-form-field>
    </div>

    <div>


        <mat-form-field>
            <mat-select [(ngModel)]="data.termin.type" [disabled]="!(firebaseService.admin | async)?.superAdmin" placeholder="Art des Eintrag">
                <mat-option value="client">Termin beim Kunden</mat-option>
                <mat-option value="urlaub">Urlaub</mat-option>
                <mat-option value="uAntrag">Urlaubsantrag</mat-option>
                <mat-option value="ausgleich">Ausgleichstag</mat-option>
                <mat-option value="krank">Krank</mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <div>


        <mat-form-field >
            <mat-label>Mitarbeiter</mat-label>
            <mat-select  [(ngModel)]="data.termin.maIds" multiple (selectionChange)="generateUmsatzObj()" [disabled]="!(firebaseService.admin | async)?.superAdmin">
                <mat-option *ngFor="let user of users" [value]="user.uid">{{user.name}}</mat-option>
            </mat-select>
        </mat-form-field>

        <ng-container *ngIf="data.termin.type">
            Kunde:
            <app-firmenname *ngIf="data.termin.clientId" [noLink]="true" [clientId]="data.termin.clientId">
            </app-firmenname>
            <span *ngIf="!data.termin.clientId">
                Kein Kunde verknüpft
            </span>
            <mat-icon style="cursor: pointer;" *ngIf="(firebaseService.admin | async)?.superAdmin" (click)="selectKunde()">edit</mat-icon>
        </ng-container>

    </div>

    <mat-form-field style="width: 100%">
        <input type="text" autocomplete="off" [disabled]="!(firebaseService.admin | async)?.superAdmin" autocorrect="off" autocapitalize="none" spellcheck="false" matInput
            placeholder="Betreff" [(ngModel)]="data.termin.Subject">
    </mat-form-field>

    <div>
        <mat-checkbox [disabled]="data.termin.type !== 'client'" [(ngModel)]="data.termin.hotel">Hotel gebucht</mat-checkbox>
    </div>
    

    <div>
        <mat-form-field style="width: 100%;">
            <input [disabled]="data.termin.type !== 'client'" type="text" autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false"
                matInput placeholder="Hotel Info" [(ngModel)]="data.termin.hotelInfo">
        </mat-form-field>
    
    </div>
    

    <mat-form-field class="full-width" style="width: 100%">
        <textarea matInput [disabled]="data.termin.type !== 'client' && !(data.termin.type === 'uAntrag' && onlyMe)" placeholder="Text" rows="4" maxrows="50" [(ngModel)]="data.termin.Description"></textarea>
    </mat-form-field>

    <div *ngIf="data.termin.type === 'client'">
        <strong>Umsatz</strong>
        <div style="display: flex;">
            <div *ngFor="let maId of data.termin.maIds; trackBy:trackByFn" style="margin-right: 10px;">
                <mat-form-field style="width: 100px">
                    <input [disabled]="!(firebaseService.admin | async)?.superAdmin" type="text" autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false"
                        matInput (change)="sanitizeUmsatz(maId)" [placeholder]="glo.getUserNameMitId(maId)"
                        [(ngModel)]="data.termin.maIdUmsatz[maId]">
                </mat-form-field>
            </div>
        </div>

        <strong>Tage ohne Frühstück</strong>
        <div style="display: flex;">
            <div *ngFor="let maId of data.termin.maIds; trackBy:trackByFn" style="margin-right: 10px;">
                <mat-form-field style="width: 100px">
                    <input type="text" autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false"
                        matInput (change)="sanitizeUmsatz(maId)" [placeholder]="glo.getUserNameMitId(maId)"
                        [(ngModel)]="data.termin.maIdNoBreakfast[maId]">
                </mat-form-field>
            </div>
        </div>

        <div style="display: flex;">
            <mat-form-field *ngIf="!data.termin.anreiseAmVortag" style="margin-right: 10px;">
                <input  type="text" autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false"
                    matInput placeholder="Uhrzeit Abreise" [(ngModel)]="data.termin.startUhrzeit">
            </mat-form-field>
            <mat-form-field *ngIf="!data.termin.anschlussTermin">
                <input type="text" autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false"
                    matInput placeholder="Uhrzeit Rückkehr" [(ngModel)]="data.termin.endUhrzeit">
            </mat-form-field>
        </div>
        <mat-checkbox [(ngModel)]="data.termin.anreiseAmVortag">Anreise am Vortag / Anschlusstermin</mat-checkbox>
        <mat-checkbox [(ngModel)]="data.termin.anschlussTermin">Abreise am Folgetag / Anschlusstermin</mat-checkbox>

    </div>

</mat-dialog-content>
<mat-dialog-actions>
    <button mat-flat-button mat-button mat-dialog-close tabindex="-1"><span>Schließen</span></button>
    <ng-container *ngIf="(firebaseService.admin | async)?.superAdmin || data.termin.type === 'client' || (data.termin.type === 'uAntrag' && onlyMe)">
        <button color="primary" mat-flat-button mat-button [disabled]="data.termin.maIds.length === 0"
            (click)="saveTermin()" type="submit"><span>Speichern</span></button>
        <button color="warn" mat-flat-button mat-button *ngIf="data.termin.Id"
            (click)="deleteTermin()"><span>Löschen</span></button>
    </ng-container>
</mat-dialog-actions>